import { characterIdsBounds } from "../bounds";
import type { BoardModelDebugMeasurable } from "../measurable";

export function characterGroupMeasurable(
  debugId: string,
  characterIds: readonly string[],
): BoardModelDebugMeasurable {
  return {
    kind: "CharacterGroup",
    debugId,
    measure: (context) =>
      characterIdsBounds(context.labelsRoot, characterIds),
  };
}
